import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { API } from '../../utils/api';

const FilterPresets = ({ currentFilters, onApplyPreset, showToast }) => {
  const { token } = useAuth();
  const [presets, setPresets] = useState([]);
  const [showSave, setShowSave] = useState(false);
  const [presetName, setPresetName] = useState('');
  const [expanded, setExpanded] = useState(false);

  const fetchPresets = useCallback(() => {
    if (!token) return;
    const x = new XMLHttpRequest();
    x.open('GET', `${API}/filter-presets`, true);
    x.setRequestHeader('Authorization', `Bearer ${token}`);
    x.onload = function () {
      if (x.status === 200) {
        try { setPresets(JSON.parse(x.responseText).presets || []); } catch (e) {}
      }
    };
    x.send();
  }, [token]);

  useEffect(() => { fetchPresets(); }, [fetchPresets]);

  const savePreset = () => {
    if (!presetName.trim()) {
      showToast && showToast('Enter a name for the preset', 'error');
      return;
    }
    const x = new XMLHttpRequest();
    x.open('POST', `${API}/filter-presets`, true);
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('Authorization', `Bearer ${token}`);
    x.onload = function () {
      if (x.status === 200) {
        showToast && showToast('Filter preset saved!', 'success');
        setPresetName('');
        setShowSave(false);
        fetchPresets();
      } else {
        try { showToast && showToast(JSON.parse(x.responseText).detail || 'Failed to save', 'error'); } catch (e) { showToast && showToast('Failed to save', 'error'); }
      }
    };
    x.send(JSON.stringify({ name: presetName, filters: currentFilters }));
  };

  const deletePreset = (presetId) => {
    const x = new XMLHttpRequest();
    x.open('DELETE', `${API}/filter-presets/${presetId}`, true);
    x.setRequestHeader('Authorization', `Bearer ${token}`);
    x.onload = function () {
      if (x.status === 200) {
        showToast && showToast('Preset deleted', 'success');
        fetchPresets();
      }
    };
    x.send();
  };

  return (
    <div style={{
      marginBottom: 12, padding: 10, background: 'rgba(245,158,11,0.05)',
      borderRadius: 10, border: '1px solid rgba(245,158,11,0.15)'
    }} data-testid="filter-presets">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 style={{ color: '#f59e0b', margin: 0, fontSize: '0.85rem', cursor: 'pointer' }}
          onClick={() => setExpanded(!expanded)} data-testid="filter-presets-toggle">
          Filter Presets ({presets.length})
          <span style={{ fontSize: '0.65rem', color: '#71717a', marginLeft: 6 }}>{expanded ? 'Collapse' : 'Expand'}</span>
        </h4>
        <button onClick={() => setShowSave(!showSave)} data-testid="save-preset-btn"
          style={{ background: 'rgba(245,158,11,0.2)', border: '1px solid rgba(245,158,11,0.3)', color: '#f59e0b', padding: '4px 10px', borderRadius: 6, fontSize: '0.72rem', cursor: 'pointer' }}>
          {showSave ? 'Cancel' : '+ Save Current'}
        </button>
      </div>

      {showSave && (
        <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
          <input value={presetName} onChange={e => setPresetName(e.target.value)} maxLength={60}
            placeholder="Preset name (e.g. PhD Research Only)" data-testid="preset-name-input"
            style={{ flex: 1, background: '#334155', border: '1px solid rgba(245,158,11,0.3)', color: '#334155', padding: '6px 10px', borderRadius: 6, fontSize: '0.78rem' }}
            onKeyDown={e => e.key === 'Enter' && savePreset()} />
          <button onClick={savePreset} data-testid="confirm-save-preset-btn"
            style={{ background: '#f59e0b', color: '#000', border: 'none', padding: '6px 12px', borderRadius: 6, fontSize: '0.75rem', cursor: 'pointer', fontWeight: 600 }}>
            Save
          </button>
        </div>
      )}

      {expanded && presets.length > 0 && (
        <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {presets.map(p => (
            <div key={p.preset_id} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <button onClick={() => onApplyPreset && onApplyPreset(p.filters)}
                data-testid={`apply-preset-${p.preset_id}`}
                style={{ background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.25)', color: '#047857', padding: '5px 10px', borderRadius: 8, fontSize: '0.72rem', cursor: 'pointer' }}>
                {p.name}
              </button>
              <button onClick={() => deletePreset(p.preset_id)}
                style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.2)', color: '#f87171', padding: '3px 6px', borderRadius: 4, fontSize: '0.6rem', cursor: 'pointer' }}>
                x
              </button>
            </div>
          ))}
        </div>
      )}

      {expanded && presets.length === 0 && (
        <p style={{ color: '#71717a', fontSize: '0.72rem', marginTop: 6 }}>No saved presets yet. Click "Save Current" to save your active filter configuration.</p>
      )}
    </div>
  );
};

export default FilterPresets;
